import { SEARCH } from './actions'

export const isSearchLoadingSelector = state => state.loading.get(SEARCH.ACTION)
